module.exports = __webpack_public_path__ + "fonts/iconfont.4adac449.woff2";